import { ArrowRight, ShieldOff } from 'lucide-react';
import { mainDomainHomeUrl, useWorkspaceStore } from '@/store/workspaceStore';

/**
 * Phase 12.1 — full-screen blocker shown when the user lands on a subdomain
 * for an archived workspace. The admin's reason (if any) is displayed verbatim
 * so users understand why they were redirected.
 */
export default function WorkspaceArchivedScreen() {
  const error = useWorkspaceStore((s) => s.error);
  const reason = error?.archivedReason?.trim();
  const slug = error?.slug ?? '';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-surface-950 px-6">
      <div className="max-w-md text-center space-y-5">
        <div className="mx-auto h-14 w-14 rounded-full bg-amber-500/10 flex items-center justify-center">
          <ShieldOff className="text-amber-400" size={26} />
        </div>
        <h1 className="text-xl font-semibold text-surface-50">
          Workspace «{slug}» закрыт
        </h1>
        {reason ? (
          <p className="text-sm text-surface-300 whitespace-pre-wrap">{reason}</p>
        ) : (
          <p className="text-sm text-surface-400">
            Этот раздел больше недоступен. Воспользуйтесь основным сайтом.
          </p>
        )}
        <a
          href={mainDomainHomeUrl()}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-brand-500 hover:bg-brand-600 text-white text-sm font-medium transition-colors"
        >
          Перейти на основной сайт <ArrowRight size={16} />
        </a>
      </div>
    </div>
  );
}
